import { fmt } from '../../utils/formatters';
import EmptyState from './EmptyState';

/* Donut chart + legend, same geometry as the approved prototype. Entries come
   from utils/charts.toChartEntries so colors stay stable per label. */
export default function DonutChart({ entries, centerCaption }) {
  const total = entries.reduce((s, e) => s + e.value, 0);
  const r = 70;
  const cx = 90;
  const cy = 90;
  const circumference = 2 * Math.PI * r;
  let offset = 0;
  const circles = entries.map((e, i) => {
    const frac = total > 0 ? e.value / total : 0;
    const slot = frac * circumference;
    const dash = Math.max(slot - 2, 0);
    const circle = (
      <circle
        key={i}
        cx={cx}
        cy={cy}
        r={r}
        fill="none"
        stroke={e.color}
        strokeWidth="26"
        strokeDasharray={`${dash} ${circumference - dash}`}
        strokeDashoffset={-offset}
        transform={`rotate(-90 ${cx} ${cy})`}
      >
        <title>{`${e.label}: ${fmt(e.value)}`}</title>
      </circle>
    );
    offset += slot;
    return circle;
  });

  return (
    <>
      <div className="pie-wrap">
        <svg viewBox="0 0 180 180" width="150" height="150">
          {circles.length ? circles : <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e6e0d2" strokeWidth="26" />}
        </svg>
        <div className="pie-center">
          <div className="v">{fmt(total)}</div>
          <div className="k">{centerCaption}</div>
        </div>
      </div>
      <div>
        {entries.length ? (
          entries.map((e, i) => {
            const pct = total > 0 ? Math.round((e.value / total) * 100) : 0;
            return (
              <div className="legend-row" key={i}>
                <span className="legend-dot" style={{ background: e.color }} />
                <span className="legend-lbl">{e.label}</span>
                <span className="legend-val">{fmt(e.value)} · {pct}%</span>
              </div>
            );
          })
        ) : (
          <EmptyState>Nothing to show yet.</EmptyState>
        )}
      </div>
    </>
  );
}
